// Explicação das regras da Campanha de Vendas 2ª Edição, exibida sob demanda (dialog "Como funciona a
// campanha") na visão do vendedor — pedido do Fernando (T.I.) numa revisão da feature.
export const REGRA1_EXPLICACAO_CAMPANHA_VENDA_MARGEM = {
  icone: 'mdi-medal-outline',
  titulo: 'Regra 1: Classificação',
  texto: 'Sua classificação (OURO, PRATA, BRONZE ou NÃO ATINGIU) depende de bater a sua meta: é isso que '
      + 'define sua classificação. Quanto mais você superar a meta, melhor ela fica. Depois, sua margem '
      + 'faz a diferença: é ela que define quantos cupons você ganha dentro da sua classificação.',
};

// tabela de cupons da Regra 1 por classificação e faixa de margem — mesmos números de
// campanhaVendaMargemFaixaMargem (base 10/5/1 pra OURO/PRATA/BRONZE, +1 a cada faixa de margem acima),
// espelhados aqui só pra exibição (pedido de dar ao vendedor uma visão tipo "tabela" completa da Regra 1,
// igual à usada nos treinamentos da campanha, em vez de só a explicação em texto corrido)
export const TABELA_REGRA1_CAMPANHA_VENDA_MARGEM = [
  {
    classificacao: 'OURO',
    atingimento: 'Acima de 102%',
    faixas: [
      { margem: 'Abaixo de 22%', cupons: 10 },
      { margem: '22% a 24%', cupons: 11 },
      { margem: '24% a 26%', cupons: 12 },
      { margem: '26% a 28%', cupons: 13 },
      { margem: 'Acima de 28%', cupons: 14 },
    ],
  },
  {
    classificacao: 'PRATA',
    atingimento: '95% a 101,99%',
    faixas: [
      { margem: 'Abaixo de 22%', cupons: 5 },
      { margem: '22% a 24%', cupons: 6 },
      { margem: '24% a 26%', cupons: 7 },
      { margem: '26% a 28%', cupons: 8 },
      { margem: 'Acima de 28%', cupons: 9 },
    ],
  },
  {
    classificacao: 'BRONZE',
    atingimento: '85% a 94,99%',
    faixas: [
      { margem: 'Abaixo de 22%', cupons: 1 },
      { margem: '22% a 24%', cupons: 2 },
      { margem: '24% a 26%', cupons: 3 },
      { margem: '26% a 28%', cupons: 4 },
      { margem: 'Acima de 28%', cupons: 5 },
    ],
  },
];

// textos alinhados com os tooltips "de verdade" da visão de diretoria (CampanhaVendaMargem.vue), que são a
// fonte oficial das regras — cupons, limiares de meta/margem e critério de disputa (rede/filial/individual)
// de cada bloco vêm de lá, pra não divergir do que o vendedor realmente ganha.
export const BLOCOS_EXPLICACAO_CAMPANHA_VENDA_MARGEM = [
  { bloco: 'Bloco A', icone: 'mdi-crown-outline', texto: 'O vendedor que mais vender no mês em toda a rede leva 15 cupons, mas só vale se ele também bater a meta (≥100%) e superar a margem mínima exigida no mês (acima de 23%). Sem essas duas condições, ninguém ganha o bloco.' },
  { bloco: 'Bloco B', icone: 'mdi-store-outline', texto: 'O vendedor que mais vender no mês na sua filial leva 10 cupons, mas só vale se ele também bater a meta (≥100%) e superar a margem mínima exigida no mês (acima de 23%). A disputa é só entre quem trabalha na sua loja.' },
  { bloco: 'Bloco C', icone: 'mdi-book-open-page-variant-outline', texto: '10 cupons: ficar entre os 10 vendedores da rede com mais pontos na campanha Educa Comercial Ivaiporã (e-book) no mês. O ranking é por pontuação, não por valor vendido.' },
  { bloco: 'Bloco D', icone: 'mdi-archive-outline', texto: '10 cupons: ficar entre os 10 vendedores da rede que mais venderam produtos "sem giro" (parados em estoque) no mês.' },
  { bloco: 'Bloco E', icone: 'mdi-target', texto: '5 cupons: atingir pelo menos 85% da meta E superar a margem mínima exigida no mesmo mês. Regra individual, sem disputa com outros vendedores.' },
  { bloco: 'Bloco F', icone: 'mdi-calendar-star', texto: '20 cupons: superar 100% da meta acumulada do trimestre com a margem mínima exigida, sem limite de vendedores. São dois trimestres na campanha: julho a setembro, e outubro a dezembro.' },
];

// dicas pra aumentar as chances de ganhar mais cupons, uma por regra/bloco (Regra 1 até Bloco F) — exibidas
// no carrossel "Dicas para ganhar mais pontos" da visão do vendedor.
// título de cada dica com quebra de linha logo após "Bloco X:"/"Regra 1:" (via \n — o template usa
// white-space: pre-line pra respeitar essa quebra), pra não truncar o resto do título num carrossel
// estreito no mobile
export const DICAS_CAMPANHA_VENDA_MARGEM = [
  {
    icone: 'mdi-medal-outline',
    titulo: 'Regra 1:\nClassificação',
    texto: 'O que define sua classificação final (BRONZE, PRATA ou OURO) é o atingimento acumulado de '
        + 'toda a campanha, não o de um mês isolado. Sua margem entra depois, definindo quantos cupons '
        + 'você ganha dentro dela.',
  },
  {
    icone: 'mdi-crown-outline',
    titulo: 'Bloco A:\nMaior venda da rede',
    texto: 'O vendedor que mais vender no mês em toda a rede leva 15 cupons, mas só vale se ele também '
        + 'bater a meta (≥100%) e superar a margem mínima exigida no mês (acima de 23%).',
  },
  {
    icone: 'mdi-store-outline',
    titulo: 'Bloco B:\nMaior venda da filial',
    texto: 'O vendedor que mais vender no mês na sua filial leva 10 cupons, desde que também bata a meta '
        + '(≥100%) e supere a margem mínima exigida no mês (acima de 23%). A vantagem é que a disputa é só '
        + 'entre os vendedores da sua loja, um grupo bem menor.',
  },
  {
    icone: 'mdi-book-open-page-variant-outline',
    titulo: 'Bloco C:\nTop 10 Educa e-book',
    texto: 'Venda e-books da campanha Educa Comercial Ivaiporã e entre no Top 10 de pontuação da rede pra '
        + 'ganhar 10 cupons extras aqui também.',
  },
  {
    icone: 'mdi-archive-outline',
    titulo: 'Bloco D:\nProduto sem giro',
    texto: 'Ajude a girar produto parado no estoque: quem mais vender itens "sem giro" e ficar entre os '
        + '10 primeiros da rede leva 10 cupons.',
  },
  {
    icone: 'mdi-target',
    titulo: 'Bloco E:\nMargem + atingimento individual',
    texto: 'Basta bater 85% de atingimento da meta E manter a margem mínima no mesmo mês pra garantir 5 '
        + 'cupons extras, sem depender de disputar com ninguém.',
  },
  {
    icone: 'mdi-calendar-star',
    titulo: 'Bloco F:\nMeta trimestral',
    texto: 'Supere 100% da meta acumulada do trimestre com a margem mínima e ganhe 20 cupons. São dois '
        + 'trimestres na campanha: julho a setembro, e outubro a dezembro. Vale mais manter um bom ritmo '
        + 'nos 3 meses do que deixar tudo para um mês só.',
  },
];
